import api from './api';

const DEMO_FLAG = 'vidal_demo_mode';
const DEMO_WELCOME_SHOWN = 'vidal_demo_welcome_shown';

export function isDemoMode() {
  try {
    return localStorage.getItem(DEMO_FLAG) === 'true';
  } catch {
    return false;
  }
}

export function hasDemoWelcomeBeenShown() {
  try {
    return localStorage.getItem(DEMO_WELCOME_SHOWN) === 'true';
  } catch {
    return false;
  }
}

export function markDemoWelcomeShown() {
  try {
    localStorage.setItem(DEMO_WELCOME_SHOWN, 'true');
  } catch { /* ignore */ }
}

export function resetDemoWelcome() {
  try {
    localStorage.removeItem(DEMO_WELCOME_SHOWN);
  } catch { /* ignore */ }
}
/**
 * Determina se uma requisição axios deve ser simulada (bloqueada) no modo demo.
 * Permite leituras (GET) e leituras-via-POST (search/count/stats/kpis).
 */
export function shouldSimulate(config = {}) {
  if (!isDemoMode()) return false;
  const method = (config.method || 'get').toLowerCase();
  if (method === 'get' || method === 'head') return false;
  const url = config.url || '';
  if (/(search|count|stats|kpis|aggregat|export|relatorio|report)/i.test(url)) return false;
  // Rotas de autenticação nunca são simuladas (login/register/etc.)
  if (/\/auth\//i.test(url)) return false;
  return true;
}

class DemoService {
  /**
   * Inicia a sessão demo: autentica na conta de demonstração e popula o localStorage.
   */
  async enterDemo() {
    const response = await api.post('/auth/demo-login');
    const { user, token, projectId } = response.data;

    const authData = { token, userId: user.id, email: user.email };
    localStorage.setItem('vidal_auth', JSON.stringify(authData));
    localStorage.setItem('vidal_user', JSON.stringify(user));
    localStorage.setItem(DEMO_FLAG, 'true');

    // Sempre tratar como usuário novo no modo demo — resetar flags de onboarding/tutorial
    localStorage.removeItem(DEMO_WELCOME_SHOWN);

    if (projectId) {
      localStorage.setItem('vidal_selected_project', projectId);
      localStorage.setItem('vidal_current_project_data', JSON.stringify({
        nome: 'VIDAL COMERCIO E DISTRIBUICAO LTDA',
        cnpj: '12345678000199',
        color: '#10b981',
        permissions: {
          files: true, transactions: true, monitoring: true, products: true,
          clients: true, suppliers: true, sped: true, xml: true, xml_scan: true,
          creditos: true, certificates: true, users: true,
        },
      }));
    }

    return { success: true, user, projectId };
  }

  exitDemo() {
    localStorage.removeItem('vidal_auth');
    localStorage.removeItem('vidal_user');
    localStorage.removeItem('vidal_selected_project');
    localStorage.removeItem('vidal_current_project_data');
    localStorage.removeItem('vidal_active_screen');
    localStorage.removeItem(DEMO_FLAG);
    localStorage.removeItem(DEMO_WELCOME_SHOWN);
  }

  hasSeenWelcome() {
    try {
      return localStorage.getItem(DEMO_WELCOME_SHOWN) === 'true';
    } catch {
      return false;
    }
  }

  markWelcomeSeen() {
    try {
      localStorage.setItem(DEMO_WELCOME_SHOWN, 'true');
    } catch { /* ignore */ }
  }
}

export default new DemoService();
